import * as React from 'react';

import AccordionBodyItem from './index';
import TextWithSubtext from 'components/TextWithSubtext';

import { AccordionBodyItemProps } from './index';

type Props = AccordionBodyItemProps & {
  subtext?: React.ReactElement | string;
  title?: string;
};

class AccordionTextWithSubtextItem extends React.Component<Props> {
  render = () => {
    const { title, subtext, ...other } = this.props;

    return (
      <AccordionBodyItem {...other}>
        <TextWithSubtext subtext={subtext} subtextSize="xsmall" textSize="xsmall" subtle>
          {title}
        </TextWithSubtext>
      </AccordionBodyItem>
    );
  };
}

export default AccordionTextWithSubtextItem;
